export const paulTolMutedColorblindSafeColors = ['#CC6677', '#332288', '#117733', '#882255', '#44aa99', '#999933', '#aa4499',];

export const COLORS = [
  ...paulTolMutedColorblindSafeColors, '#e6194b', '#3cb44b', '#4363d8', '#911eb4', '#46f0f0',
  '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8',
  '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080', '#ffffff',
  '#000000'
];
